var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-class=\"vm.state.cls\" ng-style=\"vm.state.style\" class=\"extendable_container overflow-hidden\"><div ng-transclude></div></div><div ng-show=\"vm.isOverflowing\" aria-hidden=\"true\" class=\"extendable_actions text-center\"><button type=\"button\" ng-click=\"vm.state.action(); $event.stopPropagation();\" class=\"btn btn-icon btn-block\"><i ng-class=\"vm.state.actionIcon\" class=\"glyphicon\"></i> {{ vm.state.actionTitle }}</button></div>");;return buf.join("");
}